export const FormulsNaming = {
  formulaDetailsIncome: 'Общий накат арендатора',
  formulaCommonTenantsIncome: 'Общий доход арендатора',
  formulaEarnAmount: 'Чистый доход арендатора',
  formulaGiveOutAmount: 'К выплате арендатору',
  formulaCompanyProfit: 'Прибыль компании',
}
export const NamesTranslation = {
  DetailsCash: 'наличные, без чаевых',
  DetailsCard: 'безналичные, без чаевых',
  DetailsTip: 'безналичные чаевые',
  ServiceCommission: 'Комиссия агрегатора',
  ParkCommission: 'Комиссия партнера',
  RetentionSum: 'Удержания',
  SurchargeSum: 'Доплаты',
  FuelSum: 'Топливо',
  DriverPercent: '% водителя',
  CompanyPercent: '% компании',
  EarnAmount: 'чистый доход арендатора',
  CommonTenantsIncome: 'общий доход арендатора',
  DetailsIncome: 'общий накат',
  FixedSum: 'фиксированная сумма',
  Cash: 'Наличка',
  FromBoard: 'От борта',
  Bonus: 'Бонус',
  TollRoad: 'Платная дорога',
  Washing: 'Мойка',
  PlatformSecurityDepositNegative: 'Возврат обеспечительного платежа',
  PlatformSecurityDepositPositive: 'Выдача обеспечительного платежа',
  PlatformSelfemployedTax: 'Автоуплата налога',
  InsuranceOsago: 'Страхование осаго',
  NewCarFundOneRent: 'Фонд новых авто',
  MaintenancePlanOneRent: 'Реестр по Т.О. и ремонту',
  AdvancePro: 'Адванс Про',
}

export const NamesTranslationCase = {
  details_cash: 'Наличные, без чаевых',
  details_card: 'Безналичные, без чаевых',
  details_tip: 'Безналичные чаевые',
  bonus: 'Бонус',
  tollRoad: 'Платная дорога',
  service_commission: 'Комиссия агрегатора',
  park_commission: 'Комиссия партнера',
  retention_sum: 'Удержания',
  surcharge_sum: 'Доплаты',
  fuel_sum: 'Топливо',
  driver_percent: '% водителя',
  company_percent: '% компании',
  fixed_sum: 'Фиксированная сумма',
  detailsIncome: 'общий накат',
  earnAmount: 'чистый доход арендатора',
  commonTenantsIncome: 'Oбщий доход арендатора',
  companyProfit: 'Прибыль компании',
  giveOutAmount: 'К выплате арендатору',
  cash: 'Наличка',
  from_board: 'От борта',
  washing: 'Мойка',
  PlatformSecurityDepositNegative: 'Возврат обеспечительного платежа',
  PlatformSecurityDepositPositive: 'Выдача обеспечительного платежа',
  platformSelfemployedTax: 'Автоуплата налога',
  insurance_osago: 'Страховое Осаго',
  newCarFundOneRent: 'Фонд новых авто',
  maintenancePlanOneRent: 'Реестр по Т.О. и ремонту',
  advancePro: 'Адванс Про',
}
